import React from 'react';
import Tooltip from '@dashboard/components/Tooltip';
import { Badge } from '@dashboard/components/ui/badge';

export default function DisabledBadge({ label = 'Disabled items are not shown to customers' }) {
  return (
    <Tooltip label={label}>
      <Badge variant="secondary" className="ml-2">
        Disabled
      </Badge>
    </Tooltip>
  );
}
